import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import {
    GridActionsParams,
    GridColDefPro,
} from '@/global/components/DataGrid/utils/types'
import Menu from '@/global/components/MenuV2'
import { hasPermission } from '@/hooks/useBackendMenu'
import { espelhoPonto } from '@/service/api'
import { axiosInstance } from '@/service/api/axios'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {
    FileChartColumnIcon,
    FileTextIcon,
    KeyboardIcon,
    Trash2Icon,
    UserRoundPenIcon,
} from 'lucide-react'
import { toast } from 'sonner'

const columns: GridColDefPro[] = [
    {
        field: 'matricula',
        headerName: 'Matrícula',
        valueGetter: ({ row }) =>
            `${row.Funcionario?.matricula ?? 0}`.padStart(9, '0'),
        width: 100,
    },
    {
        field: 'nome',
        headerName: 'Funcionário',
        valueGetter: ({ row }) => row.Funcionario.nome,
        minWidth: 200,
        flex: 1,
    },
    {
        field: 'totHrsATrabalhar',
        headerName: 'H. a trabalhar',
        headerAlign: 'center',
        align: 'center',
        width: 110,
    },
    {
        field: 'totHrsTrabalhadas',
        headerName: 'H. trabalhadas',
        headerAlign: 'center',
        align: 'center',
        width: 116,
    },
    {
        field: 'totFaltasIntegrais',
        headerName: 'Faltas integrais',
        headerAlign: 'center',
        align: 'center',
        width: 116,
    },
    {
        field: 'totFaltasParciais',
        headerName: 'Faltas parciais',
        headerAlign: 'center',
        align: 'center',
        width: 112,
    },
    {
        field: 'totHrsExtras',
        headerName: 'H. extras',
        width: 80,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'totSobreaviso',
        headerName: 'Sobreaviso',
        width: 70,
        align: 'center',
    },
    {
        field: 'totAdicNoturno',
        headerName: 'Adic. noturno',
        width: 80,
        align: 'center',
    },
    {
        field: 'createdAt',
        headerName: 'Gerado em',
        width: 140,
        valueFormatter: ({ value }) => {
            return dayjs(value as string).format('DD/MM/YYYY HH:mm')
        },
    },
    {
        ...optionsColumn,
        field: '__actions',
        type: 'actions',
        getActions: params => [
            hasPermission(['update', 'Funcionários'], () => (
                <Menu.Item
                    href={`/cadastros/funcionarios/${params.row.funcionarioId}/editar`}
                >
                    <Menu.Item.Icon>
                        <UserRoundPenIcon />
                    </Menu.Item.Icon>
                    <Menu.Item.Text>Editar funcionário</Menu.Item.Text>
                </Menu.Item>
            )),
            hasPermission(['read', 'Digitação'], () => (
                <DigitacaoMenuItem {...params} />
            )),
            hasPermission(['read', 'EspelhoDoPonto'], () => (
                <EspelhoPontoMenuItem {...params} />
            )),
            <Menu.Item onClick={() => downloadPdf(params.row)}>
                <Menu.Item.Icon>
                    <FileTextIcon />
                </Menu.Item.Icon>
                <Menu.Item.Text>Baixar PDF</Menu.Item.Text>
            </Menu.Item>,
            hasPermission(['delete', 'CálculoDoPonto'], () => (
                <Menu.Item href={`${params.row.id}/excluir`}>
                    <Menu.Item.Icon>
                        <Trash2Icon className="text-red-500" />
                    </Menu.Item.Icon>
                    <Menu.Item.Text>Excluir</Menu.Item.Text>
                </Menu.Item>
            )),
        ],
    },
]

function DigitacaoMenuItem(params: GridActionsParams) {
    const setEmployeeId = useStore(state => state.setEmployeeId)

    return (
        <Menu.Item
            href="/manutencao-ponto/digitacao"
            onClick={() => setEmployeeId(params.row.funcionarioId)}
        >
            <Menu.Item.Icon>
                <KeyboardIcon />
            </Menu.Item.Icon>
            <Menu.Item.Text>Digitação</Menu.Item.Text>
        </Menu.Item>
    )
}

function EspelhoPontoMenuItem(params: GridActionsParams) {
    const setEmployeeId = useStore(state => state.setEmployeeId)

    return (
        <Menu.Item
            href={`/relatorios/espelho-ponto`}
            onClick={() => setEmployeeId(params.row.funcionarioId)}
        >
            <Menu.Item.Icon>
                <FileChartColumnIcon />
            </Menu.Item.Icon>
            <Menu.Item.Text>Relátorio</Menu.Item.Text>
        </Menu.Item>
    )
}

function handleErr(e: any) {
    toast.error(e.message || 'Erro ao baixar arquivo')
}

function fetchFile(file: string) {
    fetch(`${axiosInstance.defaults.baseURL}${espelhoPonto.url}/pdf/${file}`)
        .then(res => {
            res.blob().then(blob => {
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = file
                a.click()
            })
        })
        .catch(handleErr)
}

async function downloadPdf(row: any) {
    if (!['null', 'undefined'].includes(String(row.filename)))
        return fetchFile(row.filename)

    return espelhoPonto
        .post(
            `pdf/${row.funcionarioId}?competencia=${row.competencia}&empresaId=${row.empresaId}`,
            {} as any,
        )
        .then(res => fetchFile(String(res)))
        .catch(handleErr)
}

export default columns
